import { render, staticRenderFns } from "./stockvalue.vue?vue&type=template&id=046f83d2&"
import script from "./stockvalue.vue?vue&type=script&lang=js&"
export * from "./stockvalue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/user/domains/b2b/htdocs/local/templates/b2bmodern_default/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('046f83d2')) {
      api.createRecord('046f83d2', component.options)
    } else {
      api.reload('046f83d2', component.options)
    }
    module.hot.accept("./stockvalue.vue?vue&type=template&id=046f83d2&", function () {
      api.rerender('046f83d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/vue/components/catalog/stockvalue.vue"
export default component.exports